import { useAppQuery } from "~/hooks/useAppQuery"
import { getPartners } from "../server/feed.functions"
import { feedPartnersQueryKey } from "../query-keys"

export function usePartners() {
  return useAppQuery({
    queryKey: feedPartnersQueryKey(),
    queryFn: () => getPartners({ data: { limit: 5 } }),
    errorMessage: "Не удалось загрузить партнеров",
  })
}
